export default {
  system: {
    security: {
      name: 'Secret Name',
      contentSecretNames: 'Content Secret Permission',
      annexSecretNames: 'Annex Secret Permission',
      namePlaceholder: 'please input secret name',
      handleDesc: 'Operating Instruction: ',
      handleDesc2: 'Operating Instruction: '
    }
  }
}
